import React from 'react'
import { Helmet } from 'react-helmet'
import Footer from '../components/Footer'
import Navbar from '../components/Navbar'
import './all.css'

const TemplateWrapper = ({ children }) => {
  return (
    <div className="main-wrapper">
      <Helmet>
        <html lang="en" />
        <title>EL-HABIB AMAZZAL - Senior Software Engineer</title>
        <meta name="description" content="Senior Software Engineer with 5+ years of experience in Go, TypeScript, and cloud technologies." />
        <meta name="keywords" content="Software Engineer, Golang, TypeScript, React, Cloud Computing, Microservices, Senior Developer" />
        <meta name="author" content="EL-HABIB AMAZZAL" />
        <meta name="theme-color" content="#2563eb" />
        <meta property="og:type" content="website" />
        <meta property="og:title" content="EL-HABIB AMAZZAL - Senior Software Engineer" />
        <meta property="og:description" content="Senior Software Engineer with 5+ years of experience in Go, TypeScript, and cloud technologies." />
        <meta property="og:url" content="https://el-habib.me" />
        <meta property="og:image" content="https://el-habib.me/img/photo.png" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:creator" content="@elhabibamazzal" />
        <meta name="twitter:title" content="EL-HABIB AMAZZAL - Senior Software Engineer" />
        <meta name="twitter:description" content="Senior Software Engineer with 5+ years of experience in Go, TypeScript, and cloud technologies." />
        <meta name="twitter:image" content="https://el-habib.me/img/photo.png" />
      </Helmet>
      <Navbar />
      <div className="container">{children}</div>
      <Footer />
    </div>
  )
}

export default TemplateWrapper
